import { Component, inject, input } from '@angular/core';
import { AutofocusDirective } from 'app/shared/form-utils/autofocus.directive';
import { ButtonDirective } from 'app/shared/ui/buttons/button.component';
import { ModalBodyComponent } from 'app/shared/ui/modals/modal-body.component';
import { ModalFooterComponent } from 'app/shared/ui/modals/modal-footer.component';
import { ModalHeaderComponent } from 'app/shared/ui/modals/modal-header.component';
import { ModalComponent } from 'app/shared/ui/modals/modal.component';
import { OverlayRef } from '../overlays';
import { DialogType } from './dialog-type.model';


@Component({
    selector: 'confirm-modal',
    imports: [
        AutofocusDirective,
        ButtonDirective,
        ModalHeaderComponent,
        ModalBodyComponent,
        ModalFooterComponent,
        ModalComponent,
    ],
    template: `
        <ui-modal>
            @if (header()) {
                <modal-header [type]="type()">
                    <div [innerHTML]="header()"></div>
                </modal-header>
            }
            <modal-body>
                <div [innerHTML]="content()"></div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-secondary" (click)="abort()" autofocus>
                    No
                </button>
                <button class="btn btn-{{ type() }}" (click)="confirm()">
                    Yes
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class ConfirmDialogComponent {

    type = input<DialogType>('info');

    header = input<string>();

    content = input<string>();

    private overlayRef = inject(OverlayRef);

    confirm() {
        this.overlayRef.close(true);
    }

    abort() {
        this.overlayRef.dismiss('abort');
    }
}
